import { WpsFormat, EtFormat, WppFormat, PdfFormat, TextFormat, ApFormat, DbsFormat, KsheetFormat, WhiteboardFormat, OfdFormat, OfdProfessionalFormat, PicFormat, LinkFormat, ArchiveFormat, AudioFormat, VideoFormat, FormFormat, PosterFormat, StickyNoteFormat, MindMappingFormat, FlowChartFormat, ResumeFormat, CadFormat, ThreeDModelFormat, S2tFormat, EbooksFormat, WpsFormatS, EtFormatS, WppFormatS, PdfFormatS, TextFormatS, ApFormatS, DbsFormatS, KsheetFormatS, WhiteboardFormatS, OfdFormatS, OfdProfessionalFormatS, PicFormatS, LinkFormatS, ArchiveFormatS, AudioFormatS, VideoFormatS, FormFormatS, PosterFormatS, StickyNoteFormatS, MindMappingFormatS, FlowChartFormatS, ResumeFormatS, CadFormatS, ThreeDModelFormatS, S2tFormatS, EbooksFormatS, FolderFormat, FolderSharedFormat, FolderRecycleFormat, FolderMobileFormat, FolderTeamFormat, FolderPrivateFormat, FolderUploadFormat, UnknownFormat, FolderFormatS, FolderSharedFormatS, FolderRecycleFormatS, FolderMobileFormatS, FolderTeamFormatS, FolderPrivateFormatS, FolderUploadFormatS, UnknownFormatS, DocUploadFlat, ShortcutSubscriptNormal } from '@kdocs/kdesign-icons-vue';

var FILETYPE_ICON_MAP = {
  'img': 'Pic',
  'zip': 'Archive',
  'doc': 'Wps',
  'xls': 'Et',
  'ppt': 'Wpp',
  'txt': 'Text',
  'pdf': 'Pdf',
  'pom': 'FlowChart',
  'pof': 'MindMapping',
  'h5': 'Link',
  'note': 'StickyNote',
  'form': 'Form',
  'video': 'Video',
  'audio': 'Audio',
  'otl': 'Fp',
  'motl': 'Fp',
  'kw': 'Whiteboard',
  'ckt': 'Poster',
  'dbt': 'Dbs',
  'ksheet': 'Ksheet',
  'ofd': 'Ofd',
  'resh': 'ResumeAssistant',
  'uof': 'Wps',
  'cad2d': 'Cad2d',
  'cad3d': 'Cad3d',
  's2t': 'S2t',
  'epub': 'Ebooks'
};
var FILETYPE_ICON_PRO_MAP = {
  'ofd': 'OfdProfessional'
};
var FOLDER_TYPE_ICON_MAP = {
  'devices': 'FolderEquipment',
  'device': 'Folder',
  'secret-folder': 'FolderPrivate',
  'trash-folder': 'FolderRecycle',
  'share-folder': 'FolderTeam',
  'sharefolder2': 'FolderShared',
  'share-folder2': 'FolderShared',
  'received-folder': 'FolderShared',
  'upload-folder': 'FolderUpload',
  'folder': 'Folder',
  'upload-file': 'FileUpload',
  'folder-normal': 'Folder',
  'folder-team': 'FolderTeam',
  'folder-shared': 'FolderShared',
  'folder-trash': 'FolderRecycle',
  'folder-secret': 'FolderPrivate',
  'folder-device': 'FolderEquipment',
  'folder-upload': 'FolderUpload',
  'file-upload': 'FileUpload'
};
var DEFAULT_ICON = 'Unknown';
var Main = {
  render: function render() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c('div', {
      staticClass: "format-icon",
      style: {
        'width': _vm.size + 'px',
        'height': _vm.size + 'px'
      }
    }, [_c(_vm.icon, {
      tag: "component",
      staticClass: "format-icon-file"
    }), _vm._v(" "), _vm.isLink ? _c('ShortcutSubscript', {
      staticClass: "kd-icon-shortcut"
    }) : _vm._e()], 1);
  },
  staticRenderFns: [],
  name: 'KFormatIcon',
  props: {
    size: {
      type: Number,
      "default": 30
    },
    fileType: {
      type: String,
      required: true,
      "default": 'unknown'
    },
    isLink: {
      type: Boolean,
      "default": false
    },
    isProMode: {
      type: Boolean,
      "default": false
    }
  },
  components: {
    WpsFormat: WpsFormat,
    EtFormat: EtFormat,
    WppFormat: WppFormat,
    PdfFormat: PdfFormat,
    TextFormat: TextFormat,
    FpFormat: ApFormat,
    DbsFormat: DbsFormat,
    KsheetFormat: KsheetFormat,
    WhiteboardFormat: WhiteboardFormat,
    OfdFormat: OfdFormat,
    OfdProfessionalFormat: OfdProfessionalFormat,
    PicFormat: PicFormat,
    LinkFormat: LinkFormat,
    ArchiveFormat: ArchiveFormat,
    AudioFormat: AudioFormat,
    VideoFormat: VideoFormat,
    FormFormat: FormFormat,
    PosterFormat: PosterFormat,
    StickyNoteFormat: StickyNoteFormat,
    MindMappingFormat: MindMappingFormat,
    FlowChartFormat: FlowChartFormat,
    ResumeAssistantFormat: ResumeFormat,
    Cad2dFormat: CadFormat,
    Cad3dFormat: ThreeDModelFormat,
    S2tFormat: S2tFormat,
    EbooksFormat: EbooksFormat,
    WpsFormatS: WpsFormatS,
    EtFormatS: EtFormatS,
    WppFormatS: WppFormatS,
    PdfFormatS: PdfFormatS,
    TextFormatS: TextFormatS,
    FpFormatS: ApFormatS,
    DbsFormatS: DbsFormatS,
    KsheetFormatS: KsheetFormatS,
    WhiteboardFormatS: WhiteboardFormatS,
    OfdFormatS: OfdFormatS,
    OfdProfessionalFormatS: OfdProfessionalFormatS,
    PicFormatS: PicFormatS,
    LinkFormatS: LinkFormatS,
    ArchiveFormatS: ArchiveFormatS,
    AudioFormatS: AudioFormatS,
    VideoFormatS: VideoFormatS,
    FormFormatS: FormFormatS,
    PosterFormatS: PosterFormatS,
    StickyNoteFormatS: StickyNoteFormatS,
    MindMappingFormatS: MindMappingFormatS,
    FlowChartFormatS: FlowChartFormatS,
    ResumeAssistantFormatS: ResumeFormatS,
    Cad2dFormatS: CadFormatS,
    Cad3dFormatS: ThreeDModelFormatS,
    S2tFormatS: S2tFormatS,
    EbooksFormatS: EbooksFormatS,
    FolderFormat: FolderFormat,
    FolderSharedFormat: FolderSharedFormat,
    FolderRecycleFormat: FolderRecycleFormat,
    FolderEquipmentFormat: FolderMobileFormat,
    FolderTeamFormat: FolderTeamFormat,
    FolderPrivateFormat: FolderPrivateFormat,
    FolderUploadFormat: FolderUploadFormat,
    UnknownFormat: UnknownFormat,
    FolderFormatS: FolderFormatS,
    FolderSharedFormatS: FolderSharedFormatS,
    FolderRecycleFormatS: FolderRecycleFormatS,
    FolderEquipmentFormatS: FolderMobileFormatS,
    FolderTeamFormatS: FolderTeamFormatS,
    FolderPrivateFormatS: FolderPrivateFormatS,
    FolderUploadFormatS: FolderUploadFormatS,
    UnknownFormatS: UnknownFormatS,
    FileUploadFormat: DocUploadFlat,
    FileUploadFormatS: DocUploadFlat,
    ShortcutSubscript: ShortcutSubscriptNormal
  },
  computed: {
    icon: function icon() {
      return (this.isProMode && FILETYPE_ICON_PRO_MAP[this.fileType] || FOLDER_TYPE_ICON_MAP[this.fileType] || FILETYPE_ICON_MAP[this.fileType] || DEFAULT_ICON) + 'Format' + (this.size >= 20 ? '' : 'S');
    }
  }
};

Main.install = function (Vue) {
  Vue.component(Main.name, Main);
};

export { Main as default };
